import * as actionTypes from './actionTypes';

export const requestUser = () => ({
    type: actionTypes.USER_REQUESTED
});

export const fulfillUserSettings = (companies, modules) => ({
    type: actionTypes.FULLFILL_USER_SETTINGS,
    payload: {companies, modules}
});

export const setCurrentModule = (module) => ({
    type: actionTypes.SET_CURRENT_MODULE,
    payload: {module}
});

export const setCurrentCompanySession = (current_company, current_office, all_companies) => {
    current_company.label = current_company.company.company_name;
    current_company.value = current_company.id;

    return {
        type: actionTypes.SET_CURRENT_COMPANY_SESSION,
        payload: {current_company, current_office, all_companies}
    }
};
